import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaBox, FaRegFilePdf } from "react-icons/fa";
import "./Home.css";
import {  useNavigate } from "react-router-dom";
import axios from "axios";
import { nodeURL } from "../configUrl";
import { toast } from "react-toastify";

const Home = () => {
  const stateredux = useSelector((store) => store.auth);
  // console.log(stateredux, "storereduxxx");
  const navigate = useNavigate();

const [gecikmisSayisi, setGecikmisSayisi] = useState(0);
const [yaklasanSayisi, setYaklasanSayisi] = useState(0);



  const getInfos = async () => {

       axios
      .get(`${nodeURL}/getTahsilatTakibi`)
      .then((response) => {
        const firmalar = response.data || [];
        setGecikmisSayisi(firmalar.filter((f) => f.vadesiGelmisToplam > 0).length);
        setYaklasanSayisi(firmalar.filter((f) => f.vadesiGelmisToplam <= 0 && f.planlananToplam > 0).length);
      })
      .catch((error) => {
        toast.error("Tahsilat bilgileri yüklenirken hata oluştu!", { position: "top-right" });
      })

  };


  useEffect(() => {
    getInfos();
  }, []);


  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4 " >Ana Sayfa</h2>
      <div className="row g-3">
        {/* Kiradaki Ürünler */}
    <div className="col-12 col-md-6 col-lg-3">
          <div  style={{cursor:'pointer'}} onClick={() => navigate("/home/teklifformuolustur")} className="custom-card card-green">
            <div className="d-flex justify-content-between align-items-center">
              <div  >
                <h5 className="card-title">Teklif Formu Oluştur </h5>
              </div>
              <FaRegFilePdf size={40} />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <div style={{cursor:'pointer'}} onClick={() => navigate("/home/kiradakiurunler")} className="custom-card card-blue">
            <div className="d-flex justify-content-between align-items-center">
              <div style={{cursor:'pointer'}} >
                <h5 className="card-title">Kiralamalar</h5>
              </div>
              <FaBox size={40} />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
  <div
    style={{
      cursor: "pointer",
      position: "relative",
      padding: "20px",
      background: "#d9534f",
      borderRadius: "15px",
      color: "white",
    }}
    onClick={() => navigate("/home/tahsilattakibi")}
    className="custom-card card-red"
  >
    <div className="d-flex justify-content-between align-items-center">
      <div>
        <h5 className="card-title">Tahsilat Takibi</h5>
      </div>

      <div className="d-flex gap-2">
        <div
          title="Gecikmiş"
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            color: "#d9534f",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          {gecikmisSayisi}
        </div>
        <div
          title="Yaklaşan"
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#ffc107",
            color: "#664d03",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          {yaklasanSayisi}
        </div>
      </div>
    </div>
  </div>
</div>

      </div>

    </div>

    
  );
};

export default Home;